<div class="popup-container">
  <button mat-dialog-close class="close-button">
    <mat-icon>close</mat-icon>
  </button>

  <a href="https://sucursalvirtual.metrogas.cl/ingreso/bienvenida" target="_blank">
    <img src="../../assets/img/aviso.jpg"
         alt="Popup Image"
         class="popup-image">
  </a>
</div>
